export default __webpack_public_path__ + "static/media/bg_pattern.c6f65553.png";